import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import ReactSelect from '../../components/ReactSelect';
import { data, dataMysql, extract, pontoVirgula, virgulaPonto } from '../../util/util';
import Data from '../../components/Data';
import { FinValor } from '../../components/FinField';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import '../../css/financeiro-parcela-pagar.css';


const isSubitemTipoFaturamentoND = (subitem) => ((subitem?.tipofaturamento ?? '') + '').trim().toLowerCase() === 'nd';

const sincronizarValorRealComFechamentoSeND = (subitem) => {
    if (!isSubitemTipoFaturamentoND(subitem)) {
        return;
    }

    const totalFechamento = virgulaPonto(subitem?.totalFechamento) || 0;
    subitem.pagamentovalorreal = totalFechamento.toFixed(2);
    subitem.pagamentosavingreal = '0.00';
};

const normalizarIdsPagamentoFormas = (subitem) => {
    const ids = [];
    const formas = subitem?.pagamentoformas;

    if (Array.isArray(formas)) {
        formas.forEach((forma) => {
            if (forma && typeof forma === 'object') {
                const valor = forma.id ?? forma.value ?? null;
                if (valor !== null && valor !== undefined && valor !== '') {
                    ids.push(String(valor));
                }
                return;
            }

            if (forma !== null && forma !== undefined && forma !== '') {
                ids.push(String(forma));
            }
        });
    }

    if (ids.length === 0) {
        const formaUnica = subitem?.pagamentoforma;
        if (formaUnica && typeof formaUnica === 'object') {
            const valor = formaUnica.id ?? formaUnica.value ?? null;
            if (valor !== null && valor !== undefined && valor !== '') {
                ids.push(String(valor));
            }
        } else if (formaUnica !== null && formaUnica !== undefined && formaUnica !== '') {
            ids.push(String(formaUnica));
        }
    }

    return Array.from(new Set(ids));
};

const obterOpcoesPagamentoSelecionadasSubitem = (subitem) => {
    const ids = normalizarIdsPagamentoFormas(subitem);
    const labelsPorId = new Map();

    const formas = subitem?.pagamentoformas;
    if (Array.isArray(formas)) {
        formas.forEach((forma) => {
            if (!forma || typeof forma !== 'object') {
                return;
            }

            const id = forma.id ?? forma.value ?? null;
            const label = forma.nome ?? forma.label ?? null;
            if (id !== null && id !== undefined && id !== '' && label) {
                labelsPorId.set(String(id), String(label));
            }
        });
    }

    const formaUnica = subitem?.pagamentoforma;
    if (formaUnica && typeof formaUnica === 'object') {
        const id = formaUnica.id ?? formaUnica.value ?? null;
        const label = formaUnica.nome ?? formaUnica.label ?? null;
        if (id !== null && id !== undefined && id !== '' && label) {
            labelsPorId.set(String(id), String(label));
        }
    }

    return ids.map((id) => ({
        value: id,
        label: labelsPorId.get(String(id)) ?? String(id),
    }));
};

const atualizarPagamentoFormasSubitem = (subitem, opcoesSelecionadas) => {
    const opcoes = Array.isArray(opcoesSelecionadas) ? opcoesSelecionadas : [];
    const opcoesNormalizadas = opcoes
        .filter((opcao) => opcao && opcao.value !== undefined && opcao.value !== null && opcao.value !== '')
        .map((opcao) => ({ value: String(opcao.value), label: opcao.label ?? String(opcao.value) }));

    subitem.pagamentoformas = opcoesNormalizadas.map((opcao) => ({
        id: opcao.value,
        nome: opcao.label,
    }));

    if (opcoesNormalizadas.length > 0) {
        subitem.pagamentoforma = {
            id: opcoesNormalizadas[0].value,
            nome: opcoesNormalizadas[0].label,
        };
    } else {
        subitem.pagamentoforma = null;
    }
};

const ExpanableComponent = ({ data, callBack, token, dados, setDados, calculaTotalOrcamento, ...props }) => {
    return (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
                {data.subitem ? data.subitem.map((row, rowIndex) => (
                    <>
                        <tr key={'r-' + rowIndex}>
                            <td style={{ padding: '8px 6px' }}>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Fornecedor Pagamento</label>
                                    <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                        value={data.subitem[rowIndex]?.fornecedorpagamento?.nome || ""}
                                        readOnly
                                    />
                                </div>
                            </td>
                            <td width={"110px"} style={{ padding: '8px 6px' }}>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Valor Real</label>
                                    <FinValor style={{ textAlign: 'right' }}
                                        decimalScale={2} fixedDecimalScale={false}
                                        value={pontoVirgula(isSubitemTipoFaturamentoND(data.subitem[rowIndex]) ? data.subitem[rowIndex].totalFechamento : data.subitem[rowIndex].pagamentovalorreal)}
                                        onValueChange={(values, { source }) => {
                                            if (source !== 'event') return;
                                            if (isSubitemTipoFaturamentoND(data.subitem[rowIndex])) return;
                                            // mesmo formato de antes (texto com vírgula)
                                            data.subitem[rowIndex].pagamentovalorreal = pontoVirgula(values.value);
                                            calculaTotalOrcamento();
                                            setDados({ ...dados });
                                        }}
                                        readOnly={isSubitemTipoFaturamentoND(data.subitem[rowIndex])}
                                    />
                                </div>
                            </td>
                            <td width={"110px"} style={{ padding: '8px 6px' }}>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Cobrado</label>
                                    <input readOnly type="text" className="fin-pp__input" style={{ paddingLeft: 14, textAlign: 'right' }}
                                        value={pontoVirgula(data.subitem[rowIndex].totalFechamento)}
                                    />
                                </div>
                            </td>
                            <td width={"110px"} style={{ padding: '8px 6px' }}>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Saving</label>
                                    <input readOnly type="text" className="fin-pp__input" style={{ paddingLeft: 14, textAlign: 'right' }}
                                        value={pontoVirgula(data.subitem[rowIndex].pagamentosavingreal)}
                                    />
                                </div>
                            </td>
                            <td style={{ padding: '8px 6px' }}>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Produto</label>
                                    <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                        value={data?.subitem[rowIndex]?.produto?.nome || ""}
                                        readOnly
                                    />
                                </div>
                            </td>
                            <td width={"170px"} style={{ padding: '8px 6px' }}>
                                <ReactSelect
                                    isMulti={true}
                                    value={obterOpcoesPagamentoSelecionadasSubitem(row)}
                                    onChange={(e) => {
                                        atualizarPagamentoFormasSubitem(data.subitem[rowIndex], e);
                                        setDados({ ...dados });
                                    }}
                                    defaultOptions
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/financeiroEspecie',
                                            token: token,
                                            params: { nome: input }
                                        })
                                            .then(response => {
                                                let options = (response.data.data || [])
                                                    .map(registro => ({ value: String(registro.id), label: registro.nome }))
                                                    .filter((registro) => ((registro.label || '') + '').trim().toLowerCase() !== 'nf');
                                                return options;
                                            })
                                            .catch(function (error) {});
                                    }}
                                />
                            </td>
                            <td width={"110px"} style={{ padding: '8px 6px' }}>
                                <ReactSelect
                                    value={row.pagamentoprazo !== null ? { value: row.pagamentoprazo, label: row.pagamentoprazoNome } : '0'}
                                    onChange={(e) => {
                                        data.subitem[rowIndex].pagamentoprazo = e.value;
                                        data.subitem[rowIndex].pagamentoprazoNome = e.label;
                                        setDados({ ...dados });
                                    }}
                                    options={[
                                        { value: '0', label: 'À vista' },
                                        { value: '15', label: '15 dias' },
                                        { value: '30', label: '30 dias' },
                                        { value: '60', label: '60 dias' },
                                        { value: '90', label: '90 dias' },
                                        { value: '120', label: '120 dias' },
                                    ]}
                                />
                            </td>
                            <td width={"150px"} style={{ padding: '8px 6px' }}>
                                <Data
                                    label="Vencimento"
                                    value={row.pagamentovencimento}
                                    onChange={(date) => {
                                        data.subitem[rowIndex].pagamentovencimento = date;
                                        setDados({ ...dados });
                                    }}
                                />
                            </td>
                            <td width={"150px"} style={{ padding: '8px 6px' }}>
                                <Data
                                    label="Entrega NF"
                                    value={row.pagamentoentreganf}
                                    onChange={(date) => {
                                        data.subitem[rowIndex].pagamentoentreganf = date;
                                        setDados({ ...dados });
                                    }}
                                />
                            </td>
                        </tr>
                        <tr key={'obs-' + rowIndex} style={{ zoom: "0.7" }}>
                            <td colSpan="12" style={{ padding: '4px 6px 8px' }}>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label">Observação</label>
                                    <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                        value={row.pagamentoobservacao}
                                        onChange={(e) => {
                                            data.subitem[rowIndex].pagamentoobservacao = e.target.value;
                                            setDados({ ...dados });
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>
                    </>
                )) : null}
            </tbody>
        </table>
    );
}

export default function CadastroOrcamento({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const usuario = localStorage.getItem("idUsuario");
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({
        modulo: 1,
        orcamentoitem: []
    });
    const [isSubmitting, setIsSubmitting] = useState(false);// 1 - orcamento
    const [isLoading, setIsLoading] = useState(!!id);
    const history = useHistory();
    let { state } = useLocation();

    const calculaTotalOrcamento = () => {
        calculaTotalOrcamento2();
        calculaTotalOrcamento2();
    }//calculaTotalOrcamento

    const calculaTotalOrcamento2 = () => {
        //var valorTotalFinalFechamento = 0;
        dados.orcamentoitem.forEach(function (valor, indexsuperior) {
            //dados.orcamentoitem[indexsuperior]["valorTotalFechamento"] = 0;
            dados.orcamentoitem[indexsuperior].subitem.forEach(function (valor, indexinferior) {
                sincronizarValorRealComFechamentoSeND(dados.orcamentoitem[indexsuperior].subitem[indexinferior]);
                var pagamentovalorreal = virgulaPonto(dados.orcamentoitem[indexsuperior].subitem[indexinferior].pagamentovalorreal);
                var totalFechamento = virgulaPonto(dados.orcamentoitem[indexsuperior].subitem[indexinferior].totalFechamento);
                var pagamentosavingreal = pagamentovalorreal - totalFechamento;
                if (pagamentosavingreal < 0) pagamentosavingreal = 0;
                dados.orcamentoitem[indexsuperior].subitem[indexinferior].pagamentosavingreal = pagamentosavingreal.toFixed(2);
                //var quantidadeFechamento = virgulaPonto(dados.orcamentoitem[indexsuperior].subitem[indexinferior].quantidadeFechamento);
                //var valorUnitarioFechamento = virgulaPonto(dados.orcamentoitem[indexsuperior].subitem[indexinferior].valorUnitarioFechamento);
                //var diariaFechamento = virgulaPonto(dados.orcamentoitem[indexsuperior].subitem[indexinferior].diariaFechamento);

                //var totalFechamento = quantidadeFechamento * diariaFechamento * valorUnitarioFechamento;
                //dados.orcamentoitem[indexsuperior].valorTotalFechamento += totalFechamento;
                //dados.orcamentoitem[indexsuperior].subitem[indexinferior].totalFechamento = totalFechamento.toFixed(2);
            });
            //valorTotalFinalFechamento += dados.orcamentoitem[indexsuperior].valorTotalFechamento;
            //dados.orcamentoitem[indexsuperior].valorTotalFechamento = dados.orcamentoitem[indexsuperior].valorTotalFechamento.toFixed(2);
        });
        //dados.valorTotalFechamento = valorTotalFinalFechamento.toFixed(2);
    }//calculaTotalOrcamento

    const buscar = () => {
        setIsLoading(true);
        api({
            method: "get",
            action: '/orcamento/' + id,
            token: token,
            params: {
                apenasPagamentos: "sim",
            }
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: ['evento']
            });
            //transforma data para javascript
            dadosRecebidos.pagamentodata = data(dadosRecebidos.pagamentodata);

            dadosRecebidos.orcamentoitem.forEach(function (item, index) {
                item.subitem.forEach(function (subitem, indexsubitem) {
                    dadosRecebidos.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento = data(dadosRecebidos.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento);
                    dadosRecebidos.orcamentoitem[index].subitem[indexsubitem].pagamentoentreganf = data(dadosRecebidos.orcamentoitem[index].subitem[indexsubitem].pagamentoentreganf);
                    sincronizarValorRealComFechamentoSeND(dadosRecebidos.orcamentoitem[index].subitem[indexsubitem]);
                    atualizarPagamentoFormasSubitem(
                        dadosRecebidos.orcamentoitem[index].subitem[indexsubitem],
                        obterOpcoesPagamentoSelecionadasSubitem(dadosRecebidos.orcamentoitem[index].subitem[indexsubitem])
                    );
                });
            });

            setDados(dadosRecebidos);
        }).catch(err => {
            // console.log(err)
        }).finally(() => { setIsLoading(false); });
    };

    const validar = () => {
        //if ((dados.orcamentoproduto === undefined) || (dados.orcamentoproduto.length === 0)) {
        //    toast.error('É necessário adicionar produtos');
        //    return false;
        //}
        return true;
    };

    const salvar = () => {
        if (!validar()) {
            return false; //para codigo aqui
        }
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        if (dados.pagamentodata) {
            dados.pagamentodata = dataMysql(dados.pagamentodata);
        }

        dados.orcamentoitem.forEach(function (item, index) {
            item.subitem.forEach(function (subitem, indexsubitem) {
                dados.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento = dataMysql(dados.orcamentoitem[index].subitem[indexsubitem].pagamentovencimento);
                dados.orcamentoitem[index].subitem[indexsubitem].pagamentoentreganf = dataMysql(dados.orcamentoitem[index].subitem[indexsubitem].pagamentoentreganf);
                const opcoesPagamento = obterOpcoesPagamentoSelecionadasSubitem(dados.orcamentoitem[index].subitem[indexsubitem]);
                const idsPagamento = opcoesPagamento
                    .map((opcao) => parseInt(opcao.value, 10))
                    .filter((idForma) => !Number.isNaN(idForma) && idForma > 0);
                dados.orcamentoitem[index].subitem[indexsubitem].pagamentoformas = idsPagamento;
                dados.orcamentoitem[index].subitem[indexsubitem].pagamentoforma = idsPagamento.length > 0 ? { id: idsPagamento[0] } : null;
            });
        });

        if (id) {//update
            api({
                method: 'put',
                action: '/orcamento/pagamento/' + id,
                token: token,
                data: {
                    ...dados,
                    ...{ operador: usuario }
                }
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/orcamento");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {//insert
            //nao tem opção de insert, apenas update
        }
    };

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Pagamento</h1>
                    </div>
                </div>
                <form onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ marginBottom: 16 }}>
                        <div className="fin-pp__filters" style={{ padding: '12px 16px' }}>
                            <div className="fin-pp__field" style={{ flex: 1 }}>
                                <label className="fin-pp__label">Evento</label>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={dados.nomeEvento}
                                    readOnly
                                />
                            </div>
                            <div className="fin-pp__field">
                                <Data
                                    label="Data"
                                    value={dados.pagamentodata}
                                    onChange={date => setDados({ ...dados, ...{ "pagamentodata": date } })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="fin-pp__card" style={{ overflow: 'hidden', marginBottom: 16 }}>
                        <DataTable
                            expandableRows
                            expandableRowsComponent={ExpanableComponent}
                            expandableRowsComponentProps={{
                                token: token,
                                setDados: setDados,
                                calculaTotalOrcamento: calculaTotalOrcamento,
                                dados: dados
                            }}
                            noDataComponent="Nenhum registro"
                            columns={[
                                {
                                    width: "400px",
                                    cell: (row, index) => (
                                        <div style={{ width: '400px', padding: '8px 0' }}>
                                            <div className="fin-pp__field">
                                                <label className="fin-pp__label">Grupo</label>
                                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                                    value={dados?.orcamentoitem[index]?.produto?.nome || ""}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    ),
                                },
                            ]}
                            data={dados.orcamentoitem}
                        />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            <FaSave size={16} style={{ marginRight: 8 }} /> {isSubmitting ? 'Salvando...' : 'Salvar'}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
